import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface ChatPosition {
  x: number // pixels from right edge
  y: number // pixels from bottom edge
}

const DEFAULT_POSITION: ChatPosition = { x: 20, y: 20 }
export const MIN_EDGE_PADDING = 20

interface ChatState {
  // Chat widget state
  open: boolean
  minimized: boolean

  // Position state
  position: ChatPosition
  isDragging: boolean

  // Theme colors from chat iframe
  primaryColor: string | null
  textColor: string | null

  // Actions
  openChat: () => void
  closeChat: () => void
  minimizeChat: () => void
  expandChat: () => void
  setPosition: (position: ChatPosition) => void
  setIsDragging: (isDragging: boolean) => void
  resetPosition: () => void
  setThemeColors: (primaryColor: string | null, textColor: string | null) => void
}

export const useChatStore = create<ChatState>()(
  persist(
    (set) => ({
      open: false,
      minimized: false,
      position: DEFAULT_POSITION,
      isDragging: false,
      primaryColor: null,
      textColor: null,

      openChat: () => set({ open: true, minimized: false }),
      closeChat: () => set({ open: false, minimized: false }),
      minimizeChat: () => set({ minimized: true }),
      expandChat: () => set({ minimized: false }),
      setPosition: (position) => set({ position }),
      setIsDragging: (isDragging) => set({ isDragging }),
      resetPosition: () => set({ position: DEFAULT_POSITION }),
      setThemeColors: (primaryColor, textColor) => set({ primaryColor, textColor }),
    }),
    {
      name: "chat-widget-storage",
      partialize: (state) => ({
        // Persist position and theme colors
        position: state.position,
        primaryColor: state.primaryColor,
        textColor: state.textColor,
      }),
    }
  )
)
